module.exports = __webpack_public_path__ + "img/Slide21.da8105a9.png";